import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './airline-contact-info.styles';

const AirlineContactInfo = props => {
  const { longDesc, isDweb = false, shouldBeH1 = false } = props;
  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details className="flexCol">
        <S.ContactInfo className="flexCol font14">
          <div dangerouslySetInnerHTML={{ __html: longDesc }}></div>
        </S.ContactInfo>
      </S.Details>
    </C.Wrap>
  );
};

export default AirlineContactInfo;
